import React from "react";
import "./CategorySales.css";

import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

const COLORS = [
  "#3B82F6",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#8B5CF6",
  "#06B6D4",
  "#F97316",
  "#84CC16",
];

const CategorySales = ({ categories }) => {
  const chartData = categories.map((item) => ({
    name: item._id || "Others",
    value: item.count || 0,
  }));

  return (
    <div className="category-sales">
      <div className="category-header">
        <h2>🥧 Category Sales</h2>
        <p>Food category distribution</p>
      </div>

      {chartData.length === 0 ? (
        <div className="category-empty">
          No category data available.
        </div>
      ) : (
        <ResponsiveContainer
          width="100%"
          height={350}
        >
          <PieChart>

            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={110}
              label
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={index}
                  fill={
                    COLORS[index % COLORS.length]
                  }
                />
              ))}
            </Pie>

            <Tooltip />

            <Legend />

          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default CategorySales;